import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Card } from "@material-ui/core";

import style from "./style";

const DesignCards = ({ svg, title, description, id, type }) => {
  const useStyles = makeStyles(style);
  const classes = useStyles();

  return (
    <Card data-aos="fade-in" className={classes.designCard} style={{gap:((window.innerWidth > 600 &&
      type === "Achievement") || (!type)) ? 30 : 0}}>
      <Grid data-aos="fade-in" container className={`${classes.svgContainer}`}>
        {((window.innerWidth > 600 &&
          type === "Achievement") || (!type)) && (<img src={svg} className={`${classes.img}`} alt="SVG" />)}
      </Grid>

      <Grid container className={`${classes.textContainer}`}>
        {id ? (
          <Typography data-aos="fade-in" variant="h5">
            0{id}
            {". "}
            {title}
          </Typography>
        ) : (
          <Typography data-aos="fade-in" variant="h5">{title}</Typography>
        )}

        <Typography data-aos="fade-in" variant="h6" className={`${classes.description}`}>
          {description}
        </Typography>
      </Grid>
    </Card>
  );
};

export default DesignCards;
